import { BrightyLogo } from './BrightyLogo';
import { NodaAppLogo, NodaCompactLogo } from './NodaLogo';
import { WolfoAppLogo } from './WolfoLogo';

export function AppLogo({ size, type = 'full' }: { size: number; type?: 'full' | 'compact' }) {
  if (__NODA__) {
    return type === 'full' ? <NodaAppLogo size={size} /> : <NodaCompactLogo size={size} />;
  }

  if (__BRIGHTY__) {
    return <BrightyLogo size={size} />;
  }

  if (__WOLFO__) {
    return <WolfoAppLogo size={size} />;
  }

  return null;
}
